@if (linkBack()) {
<button
  class="text-accent-900 cursor-pointer"
  [clicks]="'volver-' + linkBackText()"
  aria-label="Volver"
  [routerLink]="linkBack()">
  <icon-ui
    name="arrow-circle-left"
    class="size-6" />
</button>
}

<h2 class="preset-title-3 md:preset-title-1 grow text-white">{{ title() }}</h2>

<ng-content select="actions"></ng-content>
